import classNames from 'classnames';
import React from 'react';
import { Badge as BBadge } from 'react-bootstrap';

const Alert = ({
  children,
  variant,
  dismissible,
  className,
  ...params
}) => (
  <div className={classNames("alert", `alert-${variant}`, className)} role="alert">
    {children}
    {dismissible && <button
      type="button"
      className="close"
      data-dismiss="alert"
      aria-label="Close">
      <span aria-hidden="true">
        <i className="fal fa-times"></i>
      </span>
    </button>}
  </div >
);

export default React.memo(Alert);